// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {
  SHOW_ARE_YOU_THERE
} from '../actions/areYouThere.js'

const initialState = {
  lastUserActivity: new Date(),
  show: false,
  expiredSession: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_ARE_YOU_THERE: {
      if (action.payload.show) {
        return {...state, ...action.payload}
      }
      return {...state, ...action.payload, lastUserActivity: new Date()}
    }
    case '@@router/LOCATION_CHANGE':
    case '@@redux-form/FOCUS':
    case '@@redux-form/CHANGE':
    case '@@redux-form/BLUR':
    case '@@redux-form/SET_SUBMIT_SUCCEEDED':
      return {...state, lastUserActivity: new Date()}
    default:
      return state
  }
}

